
<div style="z-index: 9999"
  style="width: 100%; height: 100%;position: relative;display: flex;flex-direction: column;align-items: center;justify-content: center;height: 100%;">
  <h2>{{data.message}}</h2>
  <mat-progress-spinner mode="indeterminate">
  </mat-progress-spinner>
</div>
